import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import cx from 'clsx';
import { v4 } from 'uuid';
import data from './data';
import SettingsLabel from '../../../components/SettingsLabel/SettingsLabel';
import GradientGalleryItem from './GradientGalleryItem/GradientGalleryItem';
import classes from './GradientsGallery.styles.less';
export default function GradientsGallery({ className, handlers }) {
    const handleGradientPick = (values) => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        handlers.setState(values.map((value) => ({ ...value, key: v4() })));
    };
    const items = data.map((item) => (_jsx(GradientGalleryItem, { values: item.values, name: item.name, onEditorOpen: handleGradientPick, className: classes.item }, item.name)));
    return (_jsxs("div", { className: cx(classes.gradientsGallery, className), children: [_jsx(SettingsLabel, { className: classes.title, children: "Gradients Gallery" }), _jsx("div", { className: classes.items, children: items })] }));
}
